<template>
    <div>
        <div class="emarticon-card">
            <div class="emarticon-card-box">
                <div v-if="!slideData.length" class="blank-box">
                    <div class="card-text-wrap">
                        <em>등록된 이마티콘이 없습니다.</em>
                    </div>
                </div>
                <swiper ref="cardSlider" :options="type === 'select' ? selectSwiperOptions : swiperOptions" :class="classname">
                    <swiper-slide v-for="(item, index) in copiedSlideData" :key="item.imageNo">
                        <card-text v-if="type !== 'select'" :in-text="item.inText" :in-price="item.inPrice"></card-text>
                        <div class="image-area">
                            <img @click="sendCardImageNo(item.id)" :src="item.cardImg" :alt="imageDesc"/>
                        </div>
                    </swiper-slide>
                </swiper>
              <div class="card-indicator" style="height:3.5rem;">
                <div class="card-scroll-area" style="height:3.5rem;">
                  <!--                  <ul v-if="'GIFT' === orderType" class="card-list">-->
<!--                  <ul class="card-list">-->
                  <ul :class="`${classname === 'product-detail-slide' ? 'product-detail-catetory' : 'card-list'}`">
                    <li v-for="(cate, index) in filteredCategory" :key="index" v-on:click="handlerListClick($event,cate.categoryNo)">
                      <button @click="selectedButton($event)" type="button" class="category">{{cate.categoryName}}</button>
                      <h2 class="blind" v-if="cate.categoryName === imageCategoryTabText">선택됨</h2>
                    </li>
                  </ul>
                  <h2 class="blind">{{imageCategoryTabText}}</h2>
                </div>
              </div>
            </div>
        </div>
        <div class="card-indicator" v-if="copiedSlideData.length > 0" >
            <div ref="slidePagenation" class="card-scroll-area">
<!--                <ul class="card-list">-->
                <ul :class="`${classname === 'product-detail-slide' ? 'product-detail-list ' : 'card-list'}`">
                    <li  v-for="(item, index) in copiedSlideData" :key="item.id"  :class="cardActive === index ? 'active' : ''">
                        <button type="button" @click="slideIndicatorHandler($event, index)" :id="item.imageNo" name="imageButton">
                            <img @click="sendCardImageNo(item.id)" :src="item.cardImg" :alt="item.imageDesc" />
                        </button>
                        <h2 class="blind" v-if="cardActive === index">선택됨</h2>
                    </li>
                </ul>
            </div>
<!--            <button @click="sendCardImageModal(true)" type="button" class="all-card">-->
<!--              <span class="blind">전체보기</span>-->
<!--            </button>-->
        </div>
    </div>
</template>

<script>
    import CardText from'@/components/common/CardText.vue';
    import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    import "swiper/css/swiper.css";
    
    export default {
        name: 'EmarticonCard',
        components: { CardText, Swiper, SwiperSlide },
        props:{
          slideData: Array,
          imageCategory: Array,
          type: String,
          orderType: String,
          imageNo:String,
          classname: String,
        },
        data() {
            const self = this;
            return {
                cardActive: 0,
                swiperOptions: { 
                    slidesPerView: 'auto', 
                    spaceBetween: 15,
                    centeredSlides: true,
                    // loop: true
                },
                selectSwiperOptions: { 
                    slidesPerView: 1, 
                    spaceBetween: 20,
                    centeredSlides: true,
                  // loop: true,
                    on: {
                        slideChange: function() {
                            self._data.cardActive = this.realIndex;
                            self.$refs.slidePagenation.scrollLeft = (self.$refs.slidePagenation.querySelector('li').offsetWidth) * this.realIndex;
                        }
                    }
                },
              /** @type {Array} 정제된 카테고리(image_master 테이블에 존재하는 categoryNo만 추린 category_master 정보이다. */
              filteredCategory: [{categoryName:'전체',categoryNo:'ALL'}],
              /** @type {Array} 카드 리스트 원본 데이터 */
              copiedSlideData : [],
              imageCategoryTabText: '전체',
              imageDesc: '',
            }
        },
      created(){
          this.copiedSlideData = [...this.slideData];
        // IMAGE_MASTER 테이블에 존재하는 category만 보여지도록 CATEGORY_MASTER 데이터 정제
        // CATEGORY_MASTER 테이블에는 존재하지만, IMAGE_MASTER 테이블에는 존재하지 않는 CATEGORY가 있을 수 있다.
        let result = this.imageCategory.filter(item =>{
          let isExisted = false;
          this.slideData.forEach(card=>{
            if(Number(item.categoryNo) === Number(card.categoryNo)){
              isExisted = true
            }
          })
          return isExisted
        })
        this.filteredCategory = [this.filteredCategory[0],...result];
      },

      mounted(){
        /** 24-01-25 구매하기,선물하기 모두 카드 이미지 목록을 받아서 선택할 수 있도록 요건 변경  */
        // if('GIFT' === this.orderType){
            // 화면 진입 초기에는 상품 정보에 맞는 imageNo를 선택
        this.setSliderIndex(this.imageNo);
            // 화면 진입 초기에는 카테고리를 "전체"로 선택
            // const buttons = document.querySelectorAll('.category')
            // buttons.forEach((btn,index)=>{
            //   if(index===0){
            //     btn.classList.add('categoryOn');
            //   }
            // })
        const category = document.querySelector('.product-detail-catetory');
        category.children[0].children[0].classList.add('active');
          // }
      },

        methods: {
          slideIndicatorHandler(e, i) {
            this.$refs.cardSlider.$swiper.slideTo(i);
            this.imageDesc = e.currentTarget.children[0].alt; //웹접근성 조치
          },

          /**
           * 선택한 이미지의 imageNo를 부모 컴포넌트에 보냄
           * @param {String} imageNo 카드 이미지 번호
           */
          sendCardImageNo(imageNo){
            this.$emit('selectedCardImageNo', imageNo)
          },
          sendCardImageModal(flag){
            this.$emit('useCardImageModal', flag)
          },

          /**
           * imageNo를 받아 imageNo에 해당하는 이미지를 slider 내에서 선택하게 한다.
           * @param {String} imageNo 이미지번호
           */
          setSliderIndex(imageNo){
            let tags = document.getElementsByName('imageButton');
            tags.forEach((el,index)=> {
              if(el.id === imageNo){
                this.imageDesc = el.children[0].alt; //웹접근성 조치
                this.$refs.cardSlider.$swiper.slideTo(index);
              }
            })
          },

          /**
           * 선택한 카테고리에 맞는 이미지들만 보여주도록 copiedSlideData 배열 조작
           * @param {Object} e 해당 태그의 event
           * @param {String} categoryNo 카테고리번호
           */
          handlerListClick(e, categoryNo) {
            // const targetChildren = Array.from(e.currentTarget.children);
            // targetChildren.forEach(item => {
            //   item.children[0].className = "";
            //   e.target === item.children[0] && e.target.classList.add('active');
            // })
            const category = document.querySelector('.product-detail-catetory');
            const target = e.target;

            this.imageCategoryTabText = e.target.textContent; //웹접근성 조치

            // category.children[0].children[0].classList.add('active');
            if(target.tagName === "BUTTON") {
              for(let i = 0; i < category.children.length; i++) {
                category.children[i].children[0].classList.remove('active');
              }

              target.classList.add('active')

              this.copiedSlideData = this.slideData.filter(card=>{
                if(categoryNo === card.categoryNo || categoryNo === 'ALL'){
                  return true;
                }
              })
              this.sendCardImageNo(this.copiedSlideData[0].imageNo)
              this.$refs.cardSlider.$swiper.slideTo(0);
            }
          },

          /**
           * 선택한 카테고리 버튼에 class 부여
           * @param {Object} e 해당 태그의 event
           */
          selectedButton(e){
            const buttons = document.querySelectorAll('.category')
            buttons.forEach(btn=>{
              if(btn.classList.contains('categoryOn')){
                btn.classList.remove('categoryOn')
              }
            })
            e.target.classList.add('categoryOn')

          }



        }
    };
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/emarticonCard.scss';

  .categoryOn{
    border: 1px solid #222;
  }
  .product-detail-wrap {
    .card-indicator {
      margin-top: rem(10);
      div {
        padding-bottom: rem(7);
      }
    }
  }
  .product-detail-slide {
    padding-left: rem(45);
    div {
      height: rem(160);
    }
    .image-area {
      //width: 100%; height: 100%;
      position: relative;
      width: rem(231);
      height: rem(151);
      border-radius: rem(15);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .product-detail-list {
    display: inline-flex;
    box-sizing: border-box;
    padding: 0 rem(60) 0 0;
    gap: rem(8);
    li {
      width: rem(80);
      height: rem(55);
      border-radius: rem(8);
      overflow: hidden;
      button {
        width: 100%;
        height: 100%;
        border-radius: rem(8);
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &.active {
        padding: 2px;
        border: 1px solid #222;
      }

    }
  }
  .product-detail-catetory {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    //padding: rem(3) 0 rem(5);
    gap: rem(8);
    li {
      flex: 0 0 auto;
      padding-bottom: rem(10);
      button{
        padding: rem(7) rem(16);
        border-radius: rem(20);
        background-color: $color-gray-200;
        @include font-size(rem(14), rem(21), 400);
        color: $color-black-400;
        letter-spacing: -0.7px;
      }
      // &:first-child { button{ background-color: $color-white; border: 1px solid $color-black-400; } }
    }
    .active {color: $color-white !important; background-color: $color-black !important; border: 1px solid $color-black-400 !important; }
  }

</style>